import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.text-templates')
  .factory('$textTemplates', textTemplatesObjectFactory);

/* @ngInject */
function textTemplatesObjectFactory($bringozFactory: $bringozFactory,
                                    TextTemplatesAPI: BringozApi,
                                    TextTemplates_DS: DataStoreConfig,
                                    TextTemplates_PN: PushNotificationsConfig) {
  function $textTemplates(id: string) {
    return $bringozFactory(id, TextTemplatesAPI, TextTemplates_DS, TextTemplates_PN);
  }

  return $textTemplates;
}
